export const ADD_TO_CART = "ADD_TO_CART";
export const GET_ENTITIES = "GET_ENTITIES";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const POPULATE_CART = "POPULATE_CART";